import Swiper, {Autoplay, Navigation, Pagination, Scrollbar} from 'swiper';
Swiper.use([Autoplay, Navigation, Pagination, Scrollbar]);

export default class Home {
    constructor() {
        if (document.getElementById('home') !== null) {
            this.initSlideshow();
            this.initReviews();
            this.initSocial();
        }
    }

    initSlideshow() {
        new Swiper('#slideshow .swiper-container', {
            slidesPerView: 1,
            autoplay: {
                delay: 2500,
            },
            speed: 1000,
        });
    }

    initReviews() {
        new Swiper('#reviews .swiper-container', {
            slidesPerView: 1,
            spaceBetween: 0,
            initialSlide: 1,
            scrollbar: {
                el: '.swiper-scrollbar',
                draggable: true,
            }
        });
    }

    initSocial() {
        new Swiper('#social .swiper-container', {
            slidesPerView: 1,
            spaceBetween: 15,
            breakpoints: {
                768: {
                    slidesPerView: 2,
                },
                1200: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                }
            }
        });
    }
}
